import { DateTime } from 'luxon';
import IndividualResultTableContainer from './individual-result-table-container';
import type { IndividualCompetitionWithVenue } from '../types/api.types';

interface IndividualCompDetailsProps {
  individualComp: IndividualCompetitionWithVenue | null | undefined;
}

export default function IndividualCompDetails({ individualComp }: IndividualCompDetailsProps) {
  if (individualComp) {
    return (
      <div>
        <h3>
          {`${DateTime.fromISO(individualComp.eventDate || '').year} ${individualComp.series} @ ${individualComp.venueName}`}
        </h3>

        <IndividualResultTableContainer compID={individualComp.id} />
      </div>
    );
  }
  return null;
}
